/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';
import type { selfServeFirstEmployerClaim } from '../models/selfServeFirstEmployerClaim';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SelfServeFirstEmployerClaimsProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get self-serve first employer claim by company UUID
   * @param companyUuid Company UUID
   * @returns any Claim found
   * @throws ApiError
   */
  public getApiServiceauthorizationProcessesSelfServeFirstEmployerClaimsByCompany(
    companyUuid: string,
  ): CancelablePromise<{
    data?: selfServeFirstEmployerClaim;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceauthorization/processes/selfServeFirstEmployerClaims/by-company/{companyUuid}',
      path: {
        'companyUuid': companyUuid,
      },
      errors: {
        404: `Claim not found for company`,
      },
    });
  }

  /**
   * Update KYB status for a self-serve company
   * @param companyUuid Company UUID
   * @param requestBody
   * @returns any Claim updated
   * @throws ApiError
   */
  public patchApiServiceauthorizationProcessesSelfServeFirstEmployerClaimsByCompanyKybStatus(
    companyUuid: string,
    requestBody: {
      kybStatus: 'pending' | 'skipped' | 'completed' | null;
    },
  ): CancelablePromise<{
    data?: selfServeFirstEmployerClaim;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceauthorization/processes/selfServeFirstEmployerClaims/by-company/{companyUuid}/kybStatus',
      path: {
        'companyUuid': companyUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid kybStatus`,
        404: `Claim not found`,
      },
    });
  }

}
